import {Injectable, OnDestroy} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {
  AppState, failMicrositeSessions,
  RouterStateUrl, selectRouter,
} from '../../core.state';

import {Store} from '@ngrx/store';
import {routerNavigationAction} from "@ngrx/router-store";
import {filter, map, takeUntil, tap, withLatestFrom} from "rxjs/operators";
import {selectManagersState} from "../manager.selectors";
import {Router} from "@angular/router";
import {Subject} from "rxjs";

@Injectable()
export class ManagerOtherEffects implements OnDestroy {
  private readonly destroy$ = new Subject<void>();

  routerNavigationManagerToProfile = createEffect(() => {
    return this.actions$.pipe(
      ofType(routerNavigationAction),
      filter((routerProps) => !(routerProps.payload.routerState as unknown as RouterStateUrl).wallet),
      filter(propVal => propVal.payload.event.url.includes('/manager') && !propVal.payload.event.url.includes('group-confirmed')),
      map(propVal => (propVal.payload.routerState as unknown as RouterStateUrl)?.params?.manager_id),
      withLatestFrom(this.store.select(selectManagersState)),
      takeUntil(this.destroy$),
      tap(([managerId, managersState]) => {
        if (Number(managerId) === managersState.my_manager?.id) {
          this._router.navigate(['/', 'syndicates', 'profile', managerId])
        }
      }))
  }, {dispatch: false});

  failMicrositeSession = createEffect(() => {
    return this.actions$.pipe(
      ofType(failMicrositeSessions),
      withLatestFrom(this.store.select(selectRouter)),
      takeUntil(this.destroy$),
      tap(([propVal, routerState]) => {
        try {
          if (routerState.state.url.includes('profile')) {
            this._router.navigate(['/', 'syndicates', 'manager', routerState.state.params.manager_id]);
          }
        } catch (e) { /* empty */ }
      })
    )
  }, {dispatch: false});

  constructor(
    public actions$: Actions,
    public store: Store<AppState>,
    private _router: Router
  ) {
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
